export default {
      id: "bowl_on_top-usage",
      viewBox: "0 0 98.258 26.398",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#bowl_on_top",
      toString: function () {
        return this.url;
      }
    }